import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { WhiteInput } from "../../../components/Inputs/InputText";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import servOcupante from "../../../services/login/servOcupante";
import servOcupanteRevisao from "../../../services/login/servOcupanteRevisao";
import styles from "./ConsultarHomologacao.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose, faInfoCircle, faPen, faSpinner, faBan, faBoxArchive } from "@fortawesome/free-solid-svg-icons";


const ConsultarHomologacaoOcupante = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [ocupante, setOcupante] = useState(null);
    const [ocupanteRevisao, setOcupanteRevisao] = useState(null);
    const [situacaoOcupanteTexto, setSituacaoOcupanteTexto] = useState("");

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const formataValores = (dados) => {
        formataSituacaoParaTexto(dados.Situacao);
    }

    useEffect(() => {
        const recuperarOcupante = async () => {
            try {
                setIsLoading(true);
                
                let dados = await servOcupante.RecuperarParaEditar(recordForEdit?.Id || recordForEdit?.row?.id);
                let dadosRevisao = await servOcupanteRevisao.listar(recordForEdit?.Id || recordForEdit?.row?.id);
                
                setIsLoading(false);
                
                formataValores(dados.Content);
                
                setOcupanteRevisao(dadosRevisao.Content);
                setOcupante(dados.Content);
            } catch (err) {
                setIsLoading(false);
                setErrorMessage(err.Message);
                setOpenErrorWindow(true);
            }
        }

        recuperarOcupante();
    }, []);

    const formataSituacaoParaTexto = (situacao) => {
        let txtSituacao = "";

        switch(situacao) {
            case 0:
                txtSituacao = "Em digitação";
                break;
            case 1:
                txtSituacao = "Pendente de homologação";
                break;
            case 2:
                txtSituacao = "Revisão";
                break;
            case 3:
                txtSituacao = "Revisão interna";
                break;
            case 4:
                txtSituacao = "Homologado";
                break;
            case 5:
                txtSituacao = "Cancelado";
                break;
            case 6:
                txtSituacao = "Inativo";
                break;
            case 7:
                txtSituacao = "Arquivado";
                break;
            default: 
                txtSituacao = "Em digitação";
                break;
        }

        setSituacaoOcupanteTexto(txtSituacao);
    }
    
    return (
        <div style={{ width: "100%", minWidth: 580, maxWidth: 580, height: "100%" }}>
            { (ocupante !== null && ocupante.Id !== 0) && (
                <div>
                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={styles.dateBox}></div><b>Data de cadastro: </b> {
                                ocupante?.DataCadastro?.includes("01/01/1900") || ocupante?.DataCadastro?.includes("01/01/0001") ?
                                    "Data ainda não definida" :
                                    format(parse(ocupante?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data de envio para homologação: </b> {
                                ocupante?.CadastradoPorAnalista ?
                                    ocupante?.DataCadastro?.includes("01/01/1900") || ocupante?.DataCadastro?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(ocupante?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        }) :
                                    ocupante?.DataEnvioHomologacao?.includes("01/01/1900") || ocupante?.DataEnvioHomologacao?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(ocupante?.DataEnvioHomologacao, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-orange']}`}></div><b>Data de prazo da análise: </b>{
                                ocupante?.CadastradoPorAnalista ?
                                    ocupante?.DataCadastro?.includes("01/01/1900") || ocupante?.DataCadastro?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(ocupante?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        }) :
                                    ocupante?.DataPrazoAnalise?.includes("01/01/1900") || ocupante?.DataPrazoAnalise?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(ocupante?.DataPrazoAnalise, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        })
                            }
                        </span>
                    </header>
                </div>
            )}
            <div className={styles.situacaoOcupante}>
                <div className={
                    ocupante?.Situacao === 0
                    ? `${styles.resultadoOcupanteParcial} + ${styles.EmDigitacao}`
                    : ocupante?.Situacao === 1
                    ? `${styles.resultadoOcupanteParcial} + ${styles.PendenteHomologacao}`
                    : ocupante?.Situacao === 2
                    ? `${styles.resultadoOcupanteParcial} + ${styles.RevisarCadastro}`
                    : ocupante?.Situacao === 3
                    ? `${styles.resultadoOcupanteParcial} + ${styles.RevisaoInternaCadastro}`
                    : ocupante?.Situacao === 4
                    ? `${styles.resultadoOcupanteParcial} + ${styles.Homologado}`
                    : ocupante?.Situacao === 5
                    ? `${styles.resultadoOcupanteParcial} + ${styles.Cancelada}`
                    : ocupante?.Situacao === 6
                    ? `${styles.resultadoOcupanteParcial} + ${styles.Inativo}`
                    : `${styles.resultadoOcupanteParcial} + ${styles.Arquivado}`
                }>
                    <h3>Resultado</h3>
                    <div className={styles.parecerSituacaoOcupante}>
                        Situação: {
                            situacaoOcupanteTexto
                        }
                        <p>
                            <FontAwesomeIcon
                                size="lg"
                                icon={
                                    ocupante?.Situacao === 0
                                    ? faPen
                                    : ocupante?.Situacao === 1
                                    ? faSpinner
                                    : ocupante?.Situacao === 2
                                    ? faInfoCircle
                                    : ocupante?.Situacao === 3
                                    ? faInfoCircle
                                    : ocupante?.Situacao === 4
                                    ? faCheck
                                    : ocupante?.Situacao === 5
                                    ? faClose
                                    : ocupante?.Situacao === 6
                                    ? faBan
                                    : faBoxArchive
                                }
                            />
                        </p>
                    </div>
                </div>
            </div>

            { (ocupante?.Situacao === 2) && (
                <div className={styles.descricao}>
                    <strong style={{ display: "block" }}>Motivo da revisão:</strong>
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                        <WhiteInput 
                            style={{ color: "#B8B8B8" }}
                            fullWidth
                            type="text"
                            minRows={4}
                            multiline
                            value={ocupanteRevisao?.at(-1)?.MotivoRevisao}
                            readOnly={true}
                        />
                    </FormControl>
                </div>
            )}

            <div style={{
                margin: "25px 40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Fechar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    );
}

export { ConsultarHomologacaoOcupante };